<template>
    <div>
        <div>
            <ul style="display: flex;justify-content: flex-start">
                <li>
                    <el-button
                            type="primary"
                            icon="el-icon-plus"
                            @click="handleAdd"
                    >创建
                    </el-button>
                </li>

                <div class="search">
                    <my-select
                            v-model="groupId"
                            label="分组"
                            :options="groups"
                            option_label="name"
                            option_value="id"
                    ></my-select>

                    <el-input
                            :placeholder="$t('m.input_keyword')"
                            v-model="keyword"
                            style="width:400px;"
                            clearable
                            @keyup.enter.native="search"
                    >
                        <el-select
                                v-model="field"
                                slot="prepend"
                                placeholder=""
                                style="width:80px;"
                        >
                            <el-option
                                    :label="$t('m.name')"
                                    value="name"
                            ></el-option>
                            <el-option
                                    :label="$t('m.note')"
                                    value="note"
                            ></el-option>
                            <el-option
                                    :label="$t('m.path')"
                                    value="path"
                            ></el-option>
                        </el-select>
                    </el-input>
                    <el-button
                            type="primary"
                            icon="el-icon-search"
                            @click="search"
                    >搜索
                    </el-button>
                </div>

                <!--<li style="flex: 1;text-align: end">-->
                    <!--<el-button-->
                            <!--type="warning"-->
                            <!--@click="dialogVisible2=true"-->
                            <!--icon="el-icon-download"-->
                            <!--round-->
                    <!--&gt;-->
                        <!--导出接口文档-->
                    <!--</el-button>-->
                <!--</li>-->
            </ul>

            <el-table
                    :data="tableData"
                    border
                    stripe
                    width="100%"
            >
                <el-table-column
                        label="ID"
                        prop="id"
                        width="100px"
                ></el-table-column>
                <el-table-column label="名称">
                    <template slot-scope="scope">
                        <i
                                class="iconfont icon-on_line1 circle"
                                v-if="scope.row.status == 1"
                        ></i>
                        <i
                                class="iconfont icon-off_line circle offline"
                                v-else
                        ></i>
                        <span :title="scope.row.note">{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="路径">
                    <template slot-scope="scope">
                        <span>/{{context}}/{{ scope.row.path }}</span>
                    </template>
                </el-table-column>

                <el-table-column label="代理地址">
                    <template slot-scope="scope">
                        <span style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{ scope.row.proxyPath }}</span>
                    </template>
                </el-table-column>

                <el-table-column label="参数">
                    <template slot-scope="scope">
                        <div>
                            <data-tag
                                    v-for="item in scope.row.p"
                                    :name="item.name"
                                    :type="item.type"
                            ></data-tag>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="updateTime"
                        label="修改时间"
                        width="170px"
                        sortable
                ></el-table-column>

                <el-table-column
                        :label="$t('m.operation')"
                        width="220px"
                >
                    <template slot-scope="scope">
                        <!--<el-button-->
                                <!--plain-->
                                <!--size="mini"-->
                                <!--type="info"-->
                                <!--@click="detail(scope.row.id)"-->
                                <!--circle-->
                        <!--&gt;<i class="iconfont icon-detail"></i>-->
                        <!--</el-button>-->
                        <el-button
                                plain
                                size="mini"
                                type="warning"
                                @click="handleEdit(scope.row.id)"
                                circle
                        >
                            <i class="el-icon-edit"></i>
                        </el-button>

                        <el-button
                                plain
                                size="mini"
                                v-if="scope.row.status == 0"
                                type="warning"
                                @click="online(scope.row.id)"
                                circle
                        >
                            <i class="iconfont icon-on_line2"></i>
                        </el-button>

                        <el-button
                                plain
                                size="mini"
                                v-if="scope.row.status == 1"
                                type="info"
                                @click="offline(scope.row.id)"
                                circle
                        >
                            <i class="iconfont icon-off_line1"></i>
                        </el-button>

                        <!--<el-button-->
                                <!--plain-->
                                <!--size="mini"-->
                                <!--v-if="scope.row.status == 1"-->
                                <!--type="primary"-->
                                <!--@click="httpTest(scope.row.id)"-->
                                <!--:title="$t('m.request_test')"-->
                                <!--circle-->
                        <!--&gt;-->
                            <!--<i class="iconfont icon-HTTPRequest"></i>-->
                        <!--</el-button>-->

                        <el-button
                                plain
                                size="mini"
                                type="danger"
                                @click="handleDelete(scope.row.id)"
                                circle
                        >
                            <i class="el-icon-delete"></i>
                        </el-button>

                    </template>
                </el-table-column>
            </el-table>

            <!--<pagination @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"-->
                        <!--:current-page="query.page" :totalPage="query.totalCount" :pageSize="query.pageSize" :pageSizes="query.pageSizes" :layout="query.layout"/>-->

        </div>
    </div>
</template>

<script>
    // import dataTag from "@/components/common/dataTag";
    // import pagination  from '@/components/page/pagination'
    import group from "@/components/api/group";
    import {CONTENT_TYPE, PREVILEGE} from "@/constant";

    export default {
        name: "agent",
        components: {
            group
        },
        data() {
            return {
                CONTENT_TYPE: Object.freeze(CONTENT_TYPE),
                PREVILEGE: Object.freeze(PREVILEGE),
                dialogVisible: false,
                dialogVisible2: false,
                dialogVisible3: false,
                dialogVisible4: false,
                keyword: null,
                field: null,
                tableData: [],
                groups: [],
                groupId: "",
                treeData: [],
                defaultProps: {
                    children: "children",
                    label: "name",
                },
                headers: {
                    Authorization: localStorage.getItem("token"),
                },
                fileList: [],
                groupFile: [],
                checkList: [],
                context: null,
                query:{
                    page: 1,
                    pageSize: 12,
                    pageSizes:[12, 24, 36],
                    totalCount: 0,//总条数，不是总页数
                    layout:'total, sizes, prev, pager, next, jumper'
                },
            };
        },
        methods: {
            getAll() {
                this.axios
                    .post("/agentConfig/getAll")
                    .then((response) => {
                        const list = response.data;
                        list.forEach((t) => {
                            const obj = JSON.parse(t.params);
                            t["p"] = obj;
                        });
                        this.query.totalCount = 30;
                        this.tableData = list;
                    })
                    .catch((error) => {
                        // this.$message.error("查询所有api失败")
                    });
            },
            search() {
                this.axios
                    .post("/agentConfig/search", {
                        keyword: this.keyword,
                        field: this.field,
                        groupId: this.groupId,
                    })
                    .then((response) => {
                        const list = response.data;
                        list.forEach((t) => {
                            const obj = JSON.parse(t.params);
                            t["p"] = obj;
                        });
                        this.tableData = list;
                    })
                    .catch((error) => {
                        this.$message.error("Search Failed");
                    });
            },
            getContext() {
                this.axios
                    .post("/agentConfig/context")
                    .then((response) => {
                        this.context = response.data;
                    })
                    .catch((error) => {
                        this.$message.error("Failed");
                    });
            },
            handleDelete(id) {
                this.$confirm('确定要删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.post("/agentConfig/delete/" + id)
                        .then((response) => {
                            this.$message.success("删除成功");
                            this.getAll()
                        }).catch((error) => {
                            this.$message.error("删除失败")
                        })
                });
            },
            online(id) {
                this.axios
                    .post("/agentConfig/online/" + id)
                    .then((response) => {
                        this.$message.success("Publish Success");
                        this.getAll();
                    })
                    .catch((error) => {
                        this.$message.error("Publish Failed");
                    });
            },
            offline(id) {
                this.axios
                    .post("/agentConfig/offline/" + id)
                    .then((response) => {
                        this.$message.success("Already Offline");
                        this.getAll();
                    })
                    .catch((error) => {
                        this.$message.error("Failed");
                    });
            },
            httpTest(id) {
                this.$router.push({path: "/agent/request", query: {id: id}});
            },
            detail(id) {
                this.$router.push({path: "/agent/detail", query: {id: id}});
            },
            handleEdit(id) {
                this.$router.push({path: "/agent/edit", query: {id: id}});
            },
            handleAdd() {
                this.$router.push({path: "/agent/add"});
            },
            getAllGroups() {
                this.axios
                    .post("/group/getAll/")
                    .then((response) => {
                        this.groups = response.data;
                    })
                    .catch((error) => {
                    });
            },
        },
        created() {
            this.getAll();
            this.getAllGroups();
            this.getContext();
        },
        //每页最多显示条数10   20   30   50
        handleSizeChange(val) {
            this.query.pageSize = val;
            this.handleCurrentChange(1)
        },
        //翻页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getAll();
        },
    };
</script>

<style scoped lang="scss">
    i {
        font-size: 14px;
    }

    .circle {
        border-radius: 10px;
        font-size: 18px;
        font-weight: 700;
        /*background-color: #05566b;*/
        padding: 3px;
        color: #08245E;
    }

    .offline {
        color: #737373;
    }

    .lock {
        color: #c10b0b;
    }

    .tag {
        margin-right: 5px;
    }

    ul {
        margin-bottom: 10px;

        li {
            display: inline-block;
            margin-right: 10px;
        }
    }

    .search {
        //padding: 10px ;
        //border: 1px solid #ccc;
    }

    .el-button--primary {
        color: #fff;
        background-color: #08245E;
        border-color: #08245E;
    }

    .el-button--primary:hover {
        background: rgba(8, 36, 94, 0.8);
        border-color: rgba(8, 36, 94, 0.8);
    }
    /*.el-button--primary.is-plain{*/
        /*font-size: 14px;*/
        /*font-family: PingFang SC;*/
        /*font-weight: 400;*/

        /*color: #fff;*/
        /*background-color: #08245E;*/
        /*border-color: #08245E;*/
    /*}*/


</style>
